//TODO Define types for queryState and variables
const annotationDetailsMessage = (queryState, variables): string | null => {
  const { status } = queryState
  const { imageName } = variables
  //TODO Use enum for queryState
  if (status === 'error') return `Failed to get annotations for ${imageName}`
  return null
}

const measurementDetailsMessage = (queryState, variables): string | null => {
  const { status } = queryState
  const { imageName } = variables
  //TODO Use enum for queryState
  if (status === 'error') return `Failed to get annotations for ${imageName}`
  return null
}

export { annotationDetailsMessage, measurementDetailsMessage }
